"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldInputWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var DomUtil_1 = require("../../utils/DomUtil");
var InputStyleName = TypeStyle.style({
    '-webkit-appearance': 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit', // override user-agent default stylesheet
});
var TextFieldInputWidget = /** @class */ (function (_super) {
    tslib_1.__extends(TextFieldInputWidget, _super);
    function TextFieldInputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComposing = false;
        _this.handleBlur = function (e) {
            var _a, _b;
            e.relatedTarget = DomUtil_1.findBlurRelatedTarget(e); // polyfill since React refuses to :(
            (_b = (_a = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleChange = function (e) {
            if (_this.props.disabled || !_this.props.handleChange) {
                return;
            }
            _this.props.handleChange(e.target.value, _this.isComposing);
        };
        _this.handleComposition = function (e) {
            if (e.type === 'compositionend') {
                _this.isComposing = false;
                _this.handleChange(e);
            }
            else {
                _this.isComposing = true;
            }
        };
        _this.handleFocus = function (e) {
            var _a, _b;
            if (DomUtil_1.shouldIgnoreFocusEvent(e)) {
                return;
            }
            (_b = (_a = _this.props).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            if (_this.props.disabled || _this.isComposing) {
                return;
            }
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleKeyUp = function (e) {
            var _a, _b;
            if (_this.props.disabled || _this.isComposing) {
                return;
            }
            (_b = (_a = _this.props).onKeyUp) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        return _this;
    }
    TextFieldInputWidget.prototype.render = function () {
        var _a = this.props, className = _a.className, inputRef = _a.inputRef, handleChange = _a.handleChange, testId = _a.testId, htmlAttrs = tslib_1.__rest(_a, ["className", "inputRef", "handleChange", "testId"]);
        return (React.createElement("input", tslib_1.__assign({}, htmlAttrs, { className: TypeStyle.classes(className, InputStyleName), "data-tb-test-id": testId + '-TextInput', onBlur: this.handleBlur, onChange: this.handleChange, onCompositionEnd: this.handleComposition, onCompositionStart: this.handleComposition, onCompositionUpdate: this.handleComposition, onFocus: this.handleFocus, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, ref: inputRef })));
    };
    TextFieldInputWidget.defaultProps = {
        type: 'text',
        value: '',
    };
    return TextFieldInputWidget;
}(React.Component));
exports.TextFieldInputWidget = TextFieldInputWidget;
//# sourceMappingURL=TextFieldInputWidget.js.map